import Axios from "axios";
import CONFIG from "../../../model/TSConfig";
import { LANGUAGE, tt } from "../../../utils/i18n/i18n";

export const fetchJetpackMonthlyParticipationCount = async (
  customerId: string,
  sts: number,
  ets: number,
  token: string
): Promise<any> => {
  // TODO JNG Define return type here
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.saasBackendUrl}/customer-dashboard/activity?ownerId=${customerId}&sts=${sts}&ets=${ets}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return res.data;
};

export const fetchCustomerStats = async (
  ownerId: string | undefined,
  startTimestamp: number,
  endTimestamp: number,
  avgBasket: number | undefined | null,
  currencyCTAValue: number | undefined | null,
  subUnits: number
) => {
  if (!ownerId) {
    alert(tt("error"));
    return;
  }

  const res = await Axios({
    method: "GET",
    url: `${CONFIG.jetpackBackendUrl}/custdash_v2/stats`,
    params: {
      ownerId,
      sts: startTimestamp,
      ets: endTimestamp,
      isAll: false,
      avgBasket,
      currencyCTAValue,
      subUnits,
      lng: LANGUAGE
    }
  });

  return res.data.payload;
};
